/** Match the persisted login convention and the token actually used by HTTP. */
export function hasClientSession(storage) {
  const loggedIn = storage.getItem('isLoggedIn')
  if (loggedIn !== 'true' && loggedIn !== true) return false
  const token = storage.getItem('token')
  if (typeof token !== 'string' || !token.trim() || /\s/.test(token)) return false
  return !['false', 'true', 'null', 'undefined', '[object Object]'].includes(token)
}
